import { FC } from 'react'
import {
  StylePartitionLeftWrapper,
  StylePartitionRightWrapper,
  StylePartitionWrapper,
} from './style'
interface PartitionProps {
  RightComponent?: FC
  LeftComponent?: FC
}
const Partition: FC<PartitionProps> = ({ RightComponent, LeftComponent }) => {
  return (
    <StylePartitionWrapper>
      <StylePartitionLeftWrapper>
        {!!LeftComponent && <LeftComponent />}
      </StylePartitionLeftWrapper>
      <StylePartitionRightWrapper>
        {!!RightComponent && <RightComponent />}
      </StylePartitionRightWrapper>
    </StylePartitionWrapper>
  )
}

export default Partition
